import axios from 'axios';

const {
  REACT_APP_API_GATEWAY_URL,
} = process.env;

const customerListPagination = async (
  key,
  q,
  pageNo,
  pageSize,
  sColumn,
  sOrder,
) => axios.get(`${REACT_APP_API_GATEWAY_URL}/users`, {
  params: {
    q,
    pageNo,
    pageSize,
    sColumn,
    sOrder,
  },
  headers: { scope: 'read:zosi_users' },
});

export const customerUserDetail = async (id) => {
  const params = new URLSearchParams({
    id,
  });
  const idFromParams = params.get('id');
  return axios.get(`${REACT_APP_API_GATEWAY_URL}/users/${idFromParams}`, {
    headers: { scope: 'read:zosi_users' },
  });
};

export const customerDetailOrderList = async (
  key,
  q,
  pageNo,
  pageSize,
  sModel,
  sColumn,
  sOrder,
  id,
) => {
  const params = new URLSearchParams({
    id,
  });
  const idFromParams = params.get('id');
  return axios.get(`${REACT_APP_API_GATEWAY_URL}/customers/${idFromParams}/orders`, {
    params: {
      q,
      pageNo,
      pageSize,
      sModel,
      sColumn,
      sOrder,
    },
    headers: { scope: 'read:zosi_users' },
  });
};

export const customerOrderListPagination = async (
  key,
  q,
  pageNo,
  pageSize,
  sModel,
  sColumn,
  sOrder,
) => axios.get(`${REACT_APP_API_GATEWAY_URL}/customers/orders`, {
  params: {
    q,
    pageNo,
    pageSize,
    sModel,
    sColumn,
    sOrder,
  },
  headers: { scope: 'read:zosi_orders' },
});

export const getCustomerOrderInvoice = async ({ id }) => {
  const params = new URLSearchParams({
    id,
  });
  const idFromParams = params.get('id');
  return axios.get(`${REACT_APP_API_GATEWAY_URL}/orders/${idFromParams}/invoice`, {
    headers: { scope: '' },
  });
};

export const getCustomerOrderDetail = async (id) => {
  const params = new URLSearchParams({
    id,
  });
  const idFromParams = params.get('id');
  return axios.get(`${REACT_APP_API_GATEWAY_URL}/customers/orders/${idFromParams}`, {
    headers: { scope: 'read:zosi_orders' },
  });
};

export const getOrderDetailCourses = async (id) => {
  const params = new URLSearchParams({
    id,
  });
  const idFromParams = params.get('id');
  return axios.get(`${REACT_APP_API_GATEWAY_URL}/orders/${idFromParams}/courses`, {
    headers: { scope: 'read:zosi_users' },
  });
};

export const getCreditMemo = async ({ id }) => {
  const params = new URLSearchParams({
    id,
  });
  const idFromParams = params.get('id');
  return axios.get(`${REACT_APP_API_GATEWAY_URL}/subscriptions/${idFromParams}/memo`, {
    headers: { scope: '' },
  });
};

export const orderRefund = async ({ data }) => axios.post(`${process.env.REACT_APP_API_GATEWAY_URL}/orders/refund`, data, {
  headers: { scope: '' },
});

export const productList = async (
  key,
  q,
  pageNo,
  pageSize,
  id,
) => {
  const params = new URLSearchParams({
    id,
  });
  const idFromParams = params.get('id');
  return axios.get(`${REACT_APP_API_GATEWAY_URL}/products/${idFromParams}`, {
    params: {
      q,
      pageNo,
      pageSize,
    },
    headers: { scope: 'read:user_products' },
  });
};
export default customerListPagination;

export const userActivityLog = async ({ data }) => axios.post(`${process.env.REACT_APP_API_GATEWAY_URL}/activity-logs`, data, {
  headers: { scope: 'create:activity_logs' },
});

export const updateCustomer = async ({ id, data }) => {
  const params = new URLSearchParams({
    id,
  });
  const idFromParams = params.get('id');
  return axios.put(`${process.env.REACT_APP_API_GATEWAY_URL}/users/${idFromParams}`, data, {
    headers: { scope: 'update:zosi_users' },
  });
};
